<template>
  <v-app :style="app_style">
    <template v-if="loading_company_settings">
      <div style="height: 100%;" class="d-flex align-center justify-center">
        <v-card flat>
          <v-card-title class="d-flex justify-center">
            <v-img class="ma-3" contain :src="logo"  max-width="300"></v-img>
            <!-- <v-img
              :src="company_logo"
            ></v-img> -->
          </v-card-title>
          <v-card-text>
            <!-- <v-progress-linear indeterminate color="white" class="mb-0" ></v-progress-linear> -->
            <v-flex light xs12 class="mt-2 text-center">
              <v-progress-circular :size="50" :width="7" :color="$vuetify.theme.isDark ? 'white' : 'black'" indeterminate></v-progress-circular>
            </v-flex>
            <v-flex light xs12 :class="['text-center', $vuetify.theme.isDark ? 'white--text' : 'black--text']">Carregando...</v-flex>
          </v-card-text>
        </v-card>
      </div>
    </template>

    <template v-if="!loading_company_settings">
      <fusion-core-app-bar v-if="oneUser"></fusion-core-app-bar>
      <fusion-core-menu v-if="oneUser"></fusion-core-menu>
  
      <app-notifications></app-notifications>
  
      
      <v-main>
        <auto-logout v-if="oneUser"></auto-logout>
        <welcome-new-user></welcome-new-user>
        <fusion-offline-message />
        <fusion-on-trial-message />
        <fusion-on-blocked-message />
        <fusion-trial-expired-message />
        <transition name="component-fade" mode="out-in">
          <!-- <loading-screen loadingColor="white"></loading-screen> -->
          <router-view></router-view>
        </transition>
        <v-snackbar v-model="snackWithButtons" :timeout="timeout" bottom left class="snack">
          {{ snackWithBtnText }}
          <v-spacer />
          <v-btn dark text color="#00f500" @click.native="refreshApp">
            {{
            snackBtnText
            }}
          </v-btn>
          <v-btn icon @click="snackWithButtons = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-snackbar>
      </v-main>
      <fusion-core-bottom-bar v-if="oneUser && isMobile"></fusion-core-bottom-bar>
    </template>

  </v-app>
</template>

<script>
import { mapActions, mapState } from "vuex";
import responsive from "@/mixins/responsive";
import FusionCoreMenu from "./components/fusion_core/FusionDrawer";
import FusionCoreAppBar from "./components/fusion_core/FusionAppBar";
import FusionCoreBottomBar from "./components/fusion_core/FusionBottomBar";
import FusionOfflineMessage from "./components/fusion_core/FusionOfflineMessage";
import FusionOnTrialMessage from "./components/fusion_core/FusionOnTrialMessage";
import FusionTrialExpiredMessage from "./components/fusion_core/FusionTrialExpiredMessage";
import AppNotifications from './components/notification/Notifications';
import FusionOnBlockedMessage from './components/fusion_core/FusionOnBlockedMessage.vue';
import AutoLogout from './components/shared/AutoLogout.vue';
import WelcomeNewUser from './components/shared/WelcomeNewUser.vue';

import Api from '@/api';

export default {
  components: {
    // CoreMenu: () => import( /*webpackChunkName: "Drawer-Core"*/ '@/components/core/Drawer'),
    FusionCoreMenu, //: () => import( /*webpackChunkName: "Drawer-Core"*/ './components/core/Drawer'),
    // CoreAppBar: () => import( /*webpackChunkName: "AppBar-Core"*/ '@/components/core/AppBar'),
    FusionCoreAppBar, //: () => import( /*webpackChunkName: "AppBar-Core"*/ './components/core/AppBar'),
    // CoreBottomBar: () => import( /*webpackChunkName: "BottomBar-Core"*/ '@/components/core/BottomBar'),
    FusionCoreBottomBar, //: () => import( /*webpackChunkName: "BottomBar-Core"*/ './components/core/BottomBar'),
    // OfflineMessage: () => import( /*webpackChunkName: "Offline-Core"*/ '@/components/core/OfflineMessage'),
    FusionOfflineMessage, //: () => import( /*webpackChunkName: "Offline-Core"*/ './components/core/OfflineMessage'),
    FusionOnTrialMessage,
    FusionOnBlockedMessage,
    FusionTrialExpiredMessage,
    LoadingScreen: () => import("@/components/shared/CardLoadingTransparent.vue"),
    AppNotifications,
    AutoLogout,
    WelcomeNewUser
  },
  data() {
    return {
      refreshing: false,
      registration: null,
      snackBtnText: "",
      snackWithBtnText: "",
      snackWithButtons: false,
      timeout: -1,
      loading_company_settings: false,
      url_defaults: [
        'app.checkbits.com.br',
        'localhost',
        'stg.checkbits.com.br'
      ]
      
    };
  },
  created() {
    // Listen for swUpdated event and display refresh snackbar as required.
    document.addEventListener("swUpdated", this.showRefreshUI, { once: true });
    // Refresh all open app tabs when a new service worker is installed.
    // navigator.serviceWorker.addEventListener("controllerchange", () => {
    //   if (this.refreshing) return;
    //   this.refreshing = true;
    //   window.location.reload();
    // });
    navigator.serviceWorker.getRegistrations().then(registrations => {
      console.log({registrations})
      for (const registration of registrations) {
        console.log({registration})
        registration.unregister();
      } 
    });
  },

  mixins: [responsive],

  mounted() {
    this.getCompanySettings();

    if (!this.isMobile) {
      this.setDrawer(true);
    } else {
      this.setDrawer(false);
    }
    if (this.oneUser && !this.loading_solutions) {
      this.setupVuetifyColors()
      this.indexSolution();
      // this.indexCustomField()
    }
  },
  methods: {
    ...mapActions({
      setDrawer: "App/setDrawer",
      setUser: "User/setUser",
      setProfile: "User/setProfile",
      indexSolution: "Solution/index",
      indexCustomField: "CustomField/index",
      writeSolutionID: "Solution/writeSolutionID",
    }),
    setupVuetifyColors(config){
      // console.log("entrou")
      // console.log(config)
      let white_label = this.oneUser.company && this.oneUser.company.data.attributes.white_label_config || {}

      const colors = config ? config : white_label;
      // console.log({th: this.$vuetify.theme})

      if (Object.keys(colors).length > 0) {
        Object.keys(colors.light_theme).forEach(color => {
          this.$vuetify.theme.themes['light'][color] = colors.light_theme[color];
        });
        Object.keys(colors.dark_theme).forEach(color => {
          this.$vuetify.theme.themes['dark'][color] = colors.dark_theme[color];
        })
      }
      this.$vuetify.theme.isDark = localStorage.getItem("is_dark_mode") == "true" ? true : false;

    },

    showRefreshUI(e) {
      // Display a snackbar inviting the user to refresh/reload the app due
      // to an app update being available.
      // The new service worker is installed, but not yet active.
      // Store the ServiceWorkerRegistration instance for later use.
      this.registration = e.detail;
      this.snackBtnText = "Recarregar";
      this.snackWithBtnText = "Nova versão disponível!";
      this.snackWithButtons = true;
    },
    refreshApp() {
      this.snackWithButtons = false;
      // Protect against missing registration.waiting.
      if (!this.registration || !this.registration.waiting) {
        return;
      }
      this.registration.waiting.postMessage("skipWaiting");
    },
    async getCompanySettings() {
      const auth_token_default = localStorage.getItem("auth_token_default");
      if (!auth_token_default && !this.is_checkbits) {
        // console.log("entrou")
        this.loading_company_settings = true;
  
        try {
          const response = await Api.Company.companySettings();
          const data = response.data;

          window.document.title = data.name ? data.name : "Checkbits";
  
          const config = {...data.config};
          const logo_dark = data.logo_dark;
          this.setupVuetifyColors(config);
        } catch (error) {
          
        } finally {
          setTimeout(() => {
            this.loading_company_settings = false;
          }, 3000);
        }
      }

    },
  },

  computed: {
    is_checkbits() {
      const current_url = window.location.hostname;

      if (this.url_defaults.includes(current_url)) 
        return true;
      
      return false;
    },
    logo() {
      const is_dark_mode = localStorage.getItem("is_dark_mode");
      // console.log("is_dark_mode", is_dark_mode);
      if (is_dark_mode == 'true' && !this.is_checkbits) {
        return process.env.VUE_APP_API_ROOT + `/company_settings/logo_dark`;
      } else {
        return process.env.VUE_APP_API_ROOT + `/company_settings/logo`;
      }
    },
    app_style() {
      let style = {background: this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].background};

      if (this.loading_company_settings) {
        style = {background: this.$vuetify.theme.isDark ? 'black' : 'white'};
      } else if (this.is_checkbits && this.$route.name == 'Login') {
        this.$vuetify.theme.themes['light'].background = '#503075';
        style = {background: this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].background};
      }

      return style;
    },
    authReady() {
      return this.$auth.check();
    },
    ...mapState({
      oneUser: state => state.User.oneUser,
      // token_access_token: state => state.User.token_access_token,
      allSolutions: state => state.Solution.allSolutions,
      loading_solutions: state => state.Solution.loading_solutions
    })
  },
  updated(){
    // this.setupVuetifyColors()
  },
  watch: {
    authReady(val) {
      if (val) {
        // console.log("comit");
        // console.log(this.$auth.user())
        this.$store.commit("User/setCurrentUser", this.$auth.user());
        this.setProfile();
        this.setupVuetifyColors()
        if (!this.loading_solutions){
          this.indexSolution();
          // this.indexCustomField()
        }
      }
    },
    oneUser(nv, ov) {
      // auto-comment// console.log({nv});

      if (nv) {
        console.log('CHECK ON COLORS')
        this.setupVuetifyColors()
        if (!this.loading_solutions){
          this.indexSolution();
          // this.indexCustomField()
        }
      } else if (nv == false) {
      }
    },
    allSolutions(nv, ov) {
      if (nv) {
        // auto-comment// console.log('set sol id');

        this.writeSolutionID({ id: nv[0].id, start: true, id_opts: nv.map(i=> i.id) });
      }
    }
  }
};
</script>

<style>
#app {
  /* background-color: #40126e !important; */
}

/* Provide better right-edge spacing when using an icon button there. */
.snack >>> .v-snack__content {
  padding-right: 16px;
}

.swal2-popup {
  font-family: "Roboto" !important;
}


.theme--light.v-text-field.v-input--is-disabled .v-input__slot::before {
  color: rgb(10, 10, 10) !important;
  border-image: repeating-linear-gradient(to right, rgb(10, 10, 10) 0px, rgb(10, 10, 10) 2px) 1 repeat !important;
}

.theme--light.v-icon.v-icon.v-icon--disabled{
  color: rgb(145, 145, 145) !important;
}
.theme--dark.v-icon.v-icon.v-icon--disabled{
  color: rgb(255, 255, 255) !important;
}

.theme--light.v-select .v-select__selection--disabled{
  color: rgb(10, 10, 10) !important;
}
.theme--dark.v-select .v-select__selection--disabled{
  color: rgb(255, 255, 255) !important;
}

.theme--dark.v-text-field.v-input--is-disabled .v-input__slot::before {
  color: rgb(212, 212, 212) !important;
  border-image: repeating-linear-gradient(to right, rgb(212, 212, 212) 0px, rgb(212, 212, 212) 2px) 1 repeat !important;
}
.theme--dark.v-input--is-disabled textarea {
  color: rgb(255, 255, 255) !important;
}

.theme--light[class$="-disabled"],
.theme--light[class*="-disabled "] fieldset {
  /* border-color: #000 !important; */
  /* line-height: 10px !important; */
  color: #eee !important; 
  /* font-size: 120px !important; */
}

.theme--light[class$="-disabled"],
.theme--light[class*="-disabled "] input{
  border-style: none;
  color: #000 !important; 
  /* font-size: 18px; */
}

.theme--dark[class$="-disabled"],
.theme--dark[class*="-disabled "] input{
  border-style: none;
  color: #ffffff !important; 
  /* font-size: 18px; */
}

.theme--light[class$="-disabled"],
.theme--light[class*="-disabled "] label{
  color: rgb(88, 88, 88) !important; 
}

.theme--dark[class$="-disabled"],
.theme--dark[class*="-disabled "] label{
  color: rgb(200, 200, 200) !important; 
}

.theme--light.v-input--is-disabled textarea {
  color: black !important;
}

.mdi-radiobox-marked::before {
  content: "\F043E";
  /* color: #1587D3 !important; */
  color: var(--v-secondary-base) !important;
}


.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.15s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
